module.exports = __webpack_public_path__ + "img/ODR.2ba7e2e9.svg";